const isTruthyAddonState = (value) => {
  if (value === true || value === 1) return true
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    return normalized === 'true' || normalized === '1'
  }
  return false
}

const getAddonCurrentState = (addon) =>
  addon?.currentState ?? addon?.crunnetState ?? addon?.current_state

const isAddonMarkedIncluded = (addon) =>
  isTruthyAddonState(getAddonCurrentState(addon)) || isTruthyAddonState(addon?.activeByDefault)

const shouldIncludeAddonByPlanToggle = (addon, planToggleValues) => {
  const hasCloudToggle = typeof planToggleValues?.cloud_email_security === 'boolean'
  const hasHumanToggle = typeof planToggleValues?.human_risk_management === 'boolean'
  if (!hasCloudToggle && !hasHumanToggle) return true

  const cloudEnabled = Boolean(planToggleValues?.cloud_email_security)
  const humanEnabled = Boolean(planToggleValues?.human_risk_management)
  const category = String(addon?.category || '').toLowerCase()
  const isSatAddon = category === 'sat'

  if (!cloudEnabled && !humanEnabled) return false
  if (!cloudEnabled && !isSatAddon) return false
  if (!humanEnabled && isSatAddon) return false
  return true
}

const deriveFallbackPlanToggleValues = (planType) => {
  const numericPlanType = Number(planType)
  if (numericPlanType === 5) {
    return {
      cloud_email_security: true,
      human_risk_management: true,
    }
  }
  if (numericPlanType === 1 || numericPlanType === 7) {
    return {
      cloud_email_security: false,
      human_risk_management: true,
    }
  }
  return {
    cloud_email_security: true,
    human_risk_management: false,
  }
}

const getEffectivePlanToggleValues = (data) => {
  const planToggleValues = data?.planToggleValues || {}
  const hasCloudToggle = typeof planToggleValues?.cloud_email_security === 'boolean'
  const hasHumanToggle = typeof planToggleValues?.human_risk_management === 'boolean'

  if (hasCloudToggle || hasHumanToggle) return planToggleValues
  return deriveFallbackPlanToggleValues(data?.planType)
}

const syncUntouchedPlanAddonsForPayload = (addonsToEdit, data, touchedAddons = {}) => {
  const planAddons = data?.addons?.[String(data?.planType)] || data?.addons?.[data?.planType] || {}
  const planToggleValues = getEffectivePlanToggleValues(data)
  const currentPlanAddonNames = new Set(
    Object.values(planAddons)
      .filter((addon) => shouldIncludeAddonByPlanToggle(addon, planToggleValues))
      .map((addon) => addon?.name)
      .filter(Boolean)
  )
  const normalizedAddons = Object.entries(addonsToEdit || {}).reduce((acc, [addonName, value]) => {
    if (!currentPlanAddonNames.has(addonName)) return acc
    acc[addonName] = value
    return acc
  }, {})

  Object.values(planAddons).forEach((addon) => {
    const addonName = addon?.name
    if (!addonName) return
    if (!currentPlanAddonNames.has(addonName)) return
    if (addon?.editable && !addon?.disabled) return

    // Keep explicit user intent untouched in payload.
    if (touchedAddons?.[addonName]) return

    normalizedAddons[addonName] = isAddonMarkedIncluded(addon)
  })

  return normalizedAddons
}

export { syncUntouchedPlanAddonsForPayload }
